import React from 'react';
import PropTypes from 'prop-types';

const Logotype = ({ width, textColor, thumbColor }) => {
    const { a, b, c } = React.useMemo(() => {
        const rand = Math.random()
            .toString(36)
            .substring(7);

        return {
            a: 'a' + rand,
            b: 'b' + rand,
            c: 'c' + rand,
        };
    }, []);

    return (
        <svg width={width} viewBox="0 0 164 37">
            <defs>
                <path
                    id={a}
                    d="M122.95 24.1v6.42c0 1.28-.1 2.46-.29 3.53 2.62-1.97 5.11-2.96 7.47-2.96 1.56 0 2.77.42 3.6 1.25.85.83 1.27 2.03 1.27 3.6v13.11h-4.4v-11.8c0-.97-.13-1.63-.4-1.97-.26-.35-.76-.52-1.48-.52-1.4 0-3.33.71-5.8 2.14v12.15h-4.4V24.11zm-15.19 18.32l-4.65-1.24c-1.54-.43-2.61-1.04-3.23-1.82a5.27 5.27 0 0 1-.92-3.32c0-1.87.54-3.17 1.63-3.88 1.08-.71 2.94-1.07 5.59-1.07 2.88.05 5.5.26 7.83.64l-.33 3c-2.98-.1-5.23-.15-6.74-.15-1.6 0-2.61.08-3.07.24-.46.15-.69.57-.69 1.26 0 .17.02.32.06.46l.09.36c.02.1.09.18.2.27l.23.2c.05.04.17.1.36.17a13.78 13.78 0 0 0 .9.29l.58.14 4.76 1.28c1.52.43 2.6 1 3.25 1.73.65.72.97 1.82.97 3.3 0 2.04-.59 3.41-1.76 4.11-1.18.7-3.23 1.05-6.14 1.05-2.64 0-5.1-.19-7.4-.57l.3-3.03c1.25.1 3.25.15 6.02.15 1.9 0 3.17-.11 3.8-.32.64-.22.96-.67.96-1.36 0-.14-.01-.27-.03-.39a1.26 1.26 0 0 0-.11-.32l-.15-.25a.78.78 0 0 0-.25-.21 3.3 3.3 0 0 0-.67-.3 10.82 10.82 0 0 0-.88-.27l-.5-.15zm-24.85-5.56v8.34c2.26.5 3.84.75 4.73.75 1.34 0 2.27-.36 2.8-1.09.5-.72.77-2.2.77-4.43 0-2.19-.24-3.7-.7-4.51-.47-.82-1.29-1.23-2.44-1.23-.8 0-1.57.17-2.33.52-.76.34-1.7.9-2.83 1.65zm-.76-5.27l.3 2.6c.8-.9 1.9-1.64 3.26-2.2 1.36-.58 2.68-.86 3.98-.86 4.02 0 6.03 3.1 6.03 9.33 0 3.3-.55 5.63-1.64 6.99-1.1 1.35-2.81 2.03-5.15 2.03-2.38 0-4.42-.57-6.13-1.71.1 1.21.13 2.42.11 3.63V56h-4.36V31.59zm-8.64 17.46h-4.38V31.6h4.38zM70.29 24h2.02c.84 0 1.26.42 1.26 1.25v1.96c0 .83-.42 1.24-1.26 1.24h-2.02c-.85 0-1.27-.41-1.27-1.24v-1.96c0-.83.42-1.25 1.27-1.25zm-4.24 7.1l-.46 4.05h-1.27c-1.24 0-3.2.53-5.83 1.57v12.33h-4.4V31.6h3.42l.4 2.57c2.52-2.05 4.95-3.07 7.28-3.07zm-20.51 3.62v8.87c0 .76.16 1.29.47 1.59.31.3.86.44 1.66.44h2.41l.47 3.2c-1.27.41-2.79.61-4.54.61-1.54 0-2.73-.44-3.55-1.31-.83-.88-1.25-2.14-1.25-3.78v-9.62H38v-2.95l3.17-.18v-5.02h4.37v5.02h5.2v3.13z"
                />
                <path
                    id={b}
                    d="M191.72 41.02h-1.94c.15 1.26.22 2.18.22 2.74v5.8h-4.37V24h4.4v10.88c0 1.15-.08 2.2-.25 3.14h1.9l4.8-6.35h4.95l-4.91 6.35c-.38.61-.87 1.11-1.47 1.5v.07c.48.32.97.9 1.47 1.72l5.48 8.25h-4.94zm-10.1 4.96l.39 2.92c-1.74.73-3.9 1.1-6.45 1.1-3.13 0-5.34-.7-6.63-2.12-1.29-1.41-1.93-3.84-1.93-7.3s.65-5.9 1.95-7.3c1.3-1.42 3.52-2.12 6.65-2.12 2.46 0 4.5.34 6.12 1.02l-.5 2.78c-1.17-.05-2.8-.08-4.87-.08-1.82 0-3.07.4-3.76 1.2-.7.81-1.04 2.3-1.04 4.5 0 2.21.35 3.73 1.04 4.55.7.81 1.94 1.22 3.76 1.22 1.91 0 3.67-.12 5.27-.37z"
                />
                <path
                    id={c}
                    d="M139.71 20.85c1.65 1.3 3.12 2.56 4.7 3.67 1.33.94 2.76 1.75 4.2 2.53a5.9 5.9 0 0 0 5.63.01c2.89-1.38 5.38-3.32 7.8-5.36l.97-.84c.01-.01.04 0 .14 0l-1.19 3.06-3.1 7.9c-.15.34-.13.55.13.84 5.13 5.75 2.7 14.38-4.68 16.76a1 1 0 0 0-.53.54c-.72 1.95-1.41 3.91-2.11 5.87-.06.16-.14.3-.27.6l-1.26-3.48c-.36-1-.7-2.03-1.09-3.02a1 1 0 0 0-.56-.52 10.22 10.22 0 0 1-4.66-16.73c.27-.3.29-.52.14-.9-1.35-3.4-2.69-6.81-4.02-10.23-.08-.19-.13-.39-.24-.7zm16.79 19.14c.03-.99-.01-1.95-.2-2.9-.32-1.6-1.13-2.88-2.8-3.37a7.5 7.5 0 0 0-3.6-.14 3.87 3.87 0 0 0-3.17 2.85c-.6 1.95-.6 3.93-.12 5.9.39 1.6 1.3 2.81 2.97 3.15 1 .2 2.06.22 3.07.13a3.75 3.75 0 0 0 3.48-2.98c.23-.86.33-1.75.37-2.64z"
                />
            </defs>
            <g>
                <g transform="translate(-38 -20)">
                    <use fill={textColor} xlinkHref={`#${a}`} />
                </g>
                <g transform="translate(-38 -20)">
                    <use fill={textColor} xlinkHref={`#${b}`} />
                </g>
                <g transform="translate(-38 -20)">
                    <use fill={thumbColor} xlinkHref={`#${c}`} />
                </g>
            </g>
        </svg>
    );
};

export default Logotype;

Logotype.propTypes = {
    width: PropTypes.number,
    textColor: PropTypes.string,
    thumbColor: PropTypes.string,
};

Logotype.defaultProps = {
    width: 164,
    textColor: '#fff',
    thumbColor: '#00B357',
};
